import { HoverText as AntdHoverText } from "@empglabs/backoffice-ui-kit"

const HoverText = props => {
  return <AntdHoverText {...props} />
}

export default HoverText
